import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";
import {AxiosResponse} from "axios";
import {ContributionLinkResponse} from "@bounce/shared/consumer/declarations";

type Variables = {
  accountId: string;
};

type Data = ContributionLinkResponse;

export const getGuestContributionLink = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(
    `/guest-payment-url/${variables.accountId}`
  );

  return result.data;
};
